import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import femaleRide from "../../images/female.svg";

const FemaleOnly = () => {
  return (
    <StyledWrapper>
      <ContentContainer>
        <TextContent>
          <HighlightBadge>For Women by Women</HighlightBadge>
          <Title>Safe & Secure Female Rides</Title>
          <Description>
            GoSawari offers exclusive, women-only rides where both the driver
            and passengers are female. Experience a safe, comfortable, and private
            journey across Pakistan.
          </Description>
          <Link to="/publish">
            <StyledButton>Offer a Ride</StyledButton>
          </Link>
        </TextContent>
        <ImageContent>
          <img src={femaleRide} alt="female-rider-pakistan-carpool" />
          <Glow />
        </ImageContent>
      </ContentContainer>
    </StyledWrapper>
  );
};

export default FemaleOnly;

const StyledWrapper = styled.section`
  padding: 5rem 2rem;
  background: #fff0f5; /* Lavender Blush */
  background: linear-gradient(135deg, #fff0f5 0%, #ffe4e6 100%);
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 3rem 1.5rem;
  }
`;

const ContentContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 4rem;

  @media (max-width: 1024px) {
    gap: 2rem;
  }

  @media (max-width: 900px) {
    flex-direction: column-reverse;
    text-align: center;
  }
`;

const TextContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 900px) {
    align-items: center;
  }
`;

const HighlightBadge = styled.span`
  background: rgba(236, 72, 153, 0.1);
  color: #db2777;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  border: 1px solid rgba(236, 72, 153, 0.2);

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
    margin-bottom: 1rem;
  }
`;

const Title = styled.h2`
  font-size: 3rem;
  font-weight: 800;
  color: #881337;
  margin-bottom: 1.5rem;
  line-height: 1.1;
  letter-spacing: -1px;

  @media (max-width: 1024px) {
    font-size: 2.2rem;
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    line-height: 1.25;
  }
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: #9d174d;
  line-height: 1.7;
  margin-bottom: 2.5rem;
  max-width: 500px;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
`;

const StyledButton = styled.button`
  background: linear-gradient(135deg, #ec4899, #db2777);
  color: white;
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(236, 72, 153, 0.3);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(236, 72, 153, 0.5);
  }
`;

const ImageContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  position: relative;
  
  img {
    width: 100%;
    max-width: 500px;
    position: relative;
    z-index: 2;
    filter: drop-shadow(0 10px 20px rgba(236, 72, 153, 0.2));
  }
`;

const Glow = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(236, 72, 153, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 1;
`;
